import React from "react";

const VoiceCallButton = () => {
  return (
    <>
      <style>{`
        @keyframes pulse-ring{0%{transform:scale(1);opacity:0.5}100%{transform:scale(1.6);opacity:0}}
        .call-widget{position:fixed;bottom:24px;right:24px;z-index:9999;display:flex;flex-direction:column;align-items:flex-end;gap:8px}
        .call-label{background:#1e1b3a;color:white;padding:10px 16px;border-radius:14px;font-size:13px;font-weight:500;box-shadow:0 8px 32px rgba(0,0,0,0.25);position:relative;white-space:nowrap}
        .call-label::after{content:'';position:absolute;bottom:-6px;right:24px;width:12px;height:12px;background:#1e1b3a;transform:rotate(45deg)}
        .call-btn{width:60px;height:60px;border-radius:50%;border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;background:linear-gradient(135deg,#22c55e,#16a34a);box-shadow:0 6px 24px rgba(34,197,94,0.4);transition:all 0.3s ease;position:relative;text-decoration:none}
        .call-btn:hover{transform:scale(1.08);box-shadow:0 8px 32px rgba(34,197,94,0.5)}
        .call-pulse{position:absolute;inset:-4px;border-radius:50%;border:2px solid rgba(34,197,94,0.4);animation:pulse-ring 2s ease-out infinite;pointer-events:none}
      `}</style>

      <div className="call-widget" data-testid="voice-call-widget">
        <div className="call-label">
          Llama ahora: <strong>930 346 922</strong>
        </div>
        <a href="tel:+34930346922" className="call-btn" data-testid="voice-call-btn">
          <div className="call-pulse" />
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
          </svg>
        </a>
      </div>
    </>
  );
};

export default VoiceCallButton;
